import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let LabelService = {};

((LabelService) =>
{
  LabelService.getAllLabels = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/labels"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

})(LabelService);

module.exports = LabelService;



// WEBPACK FOOTER //
// ./app/js/services/label-service.js